import { cvc } from 'creditcards';

export default (cvcCode) => {
  return cvc.isValid(cvcCode);
}
